<template>
  <div class="left-search tree-container">
    <div class="tabLine">
      <div class="tabs">
        <div
          class="lineItem borderMid cursor"
          :class="{ lineItemHight: currentIndex === 'user' }"
          @click="changeType('user')"
        >
          {{ $t('viewByUser') }}
        </div>
        <div
          class="lineItem borderRight cursor"
          :class="{ lineItemHight: currentIndex === 'type' }"
          @click="changeType('type')"
        >
          {{ $t('viewCategory') }}
        </div>
      </div>
    </div>
    <div class="serach ">
      <div class="tip"></div>
      <el-input
        :placeholder="currentIndex == 'type' ? $t('searchTypeName') : $t('searchUsername')"
        clearable
        v-model="query.mediaTypeName"
      >
      </el-input>
    </div>
    <el-tree
      :data="mechanismData"
      :props="defaultProps"
      node-key="id"
      default-expand-all
      :expand-on-click-node="false"
      @node-click="handleNodeClick"
      highlight-current
      :filter-node-method="filterNode"
      ref="dataStaticTree"
      class="dataStaticTree"
    >
      <span class="custom-tree-node" slot-scope="{ node }">
        <template>
          <i class="leaf-node-line" v-if="firstNode.id !== node.data.id"></i>
          <span>
            <span class="tenant" v-if="node.data.userId || !node.data.path">{{ node.data.name }}</span>
            <span class="node-txt" v-else>{{ node.data.name }}</span>
          </span>
        </template>
      </span>
    </el-tree>
  </div>
</template>
<script>
import { attributeTree } from '@/api/new-device/categoryAttribut'
import { findDeviceList } from '@/api/monitor'
export default {
  data() {
    return {
      currentIndex: 'user',
      query: {
        mediaTypeName: '',
      },
      mechanismData: [],
      defaultProps: {
        label: 'name',
        children: 'children',
      },
      currentNode: null,
      firstNode: null,
    }
  },
  props: {
    // 从人员统计跳转过来
    dataUserId: {
      type: String,
    },
  },
  watch: {
    // 机构树搜索用户名/名字监听
    'query.mediaTypeName'(val) {
      this.query.mediaTypeName = val
      this.$refs.dataStaticTree.filter(val)
    },
    dataUserId: {
      handler(val) {
        if (val) {
          this.userHandle(val)
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 从人员统计跳转过来
    userHandle(val) {
      this.currentIndex = 'user'
      this.query.mediaTypeName = ''
      this._findUserList()
    },
    // tab切换
    changeType(index) {
      if (index) {
        this.currentIndex = index
      }
      if (this.currentIndex === 'type') {
        this.query.mediaTypeName = ''
        this.getOusTree()
      } else {
        this.query.mediaTypeName = ''
        this._findUserList()
      }
    },
    // 获取组织机构
    getOusTree() {
      let param = {
        isContainMediaType: 0,
        name: this.query.mediaTypeName,
        isReject: 1, // 1:不包含 0:包含
      }
      attributeTree(param).then(res => {
        if (res.state === 0) {
          this.mechanismData = res.value
          console.log(res.value, 'res.data')
          this.firstNode = res.value && res.value[0] ? res.value[0] : null
          this.$emit('handleItem', null, this.currentIndex, this.mechanismData)
        }
      })
    },
    // 查询全部用户
    _findUserList() {
      let param = {
        userName: this.query.mediaTypeName,
        statusList: [0, 1, 2],
      }
      findDeviceList(param).then(res => {
        if (res.state === 0 && res.data[0]) {
          console.log(res.data, 'res.data')
          this.mechanismData = res.data
          this.firstNode = res.data[0]
        } else {
          this.mechanismData = null
        }
        this.$emit('handleItem', null, this.currentIndex, null)
      })
    },
    // 当前归属/用户
    handleNodeClick(data, node) {
      if (this.currentNode && this.currentNode.name === data.name) {
        node.checked = !node.checked
      } else {
        node.checked = true
      }
      if (node.checked) {
        // 选中
        this.currentNode = data
      } else {
        // 取消选中
        if (this.$refs.dataStaticTree) {
          this.$refs.dataStaticTree.setCurrentKey(null)
        }

        this.currentNode = null
      }
      this.$emit('handleItem', this.currentNode, this.currentIndex, null)
    },
    // 节点过滤
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
  },
  mounted() {
    this.changeType()
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/new-set-common.styl'
@import '~@/style/tree-line.styl'
.left-search
  width: 15%
  height: 100%
  background-color: #eff1f4;
  >>>.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content
    color: #2372df !important;
  .el-tree
    border-top: var(--aside-tree-border-bottom);
    color: var(--table-color);
    .custom-tree-node
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-right: 0.10416667rem;
      width: 100%;
      .node-txt
        font-size 16px;/*no*/
        color: #222;
        font-weight: 600;
      .tenant
        font-size 16px;/*no*/
      span
        display: inline-block
        width: 100%
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
  .tabLine
    padding: 15px 0
    margin: 0 10px
    .tabs
      display flex
      justify-content: center
      width 100%
      height: 36px;
      line-height: 36px;
      margin: 0 auto
      border-radius: 6px
      color: #2372df
      box-sizing: border-box
    .lineItem
      font-weight: bold;
      text-align: center
      width: 50%;
      box-sizing: border-box
    .lineItemHight
      background: #0e65dd
      color #fff
    .borderMid
      border-top: 2px solid var(--boredr-color);
      border-left: 2px solid var(--boredr-color);
      border-bottom: 2px solid var(--boredr-color);
    .borderRight
      border-top: 2px solid var(--boredr-color);
      border-right: 2px solid var(--boredr-color);
      border-bottom: 2px solid var(--boredr-color);
  .serach
    display: flex
    align-items: center
    background: #E2E6EC;
    padding: 10px
    .tip
      width: 5px
      height: 30px
      margin-right: 10px
      background: #0e65dd
      border-radius: 4px
    >>>.el-input
      width: calc(100% - 15px)!important;
      vertical-align: middle
      .el-input__inner
        height: 30px
        border-radius: 6px
        border: 1px solid var(--boredr-color)
        background-color: #fff
        color: #333
        font-size: 14px
        height: 36px;/*no*/
        line-height: 36px;/*no*/
        padding: 0 10px
        &::placeholder
          color: #999
  .dataStaticTree
    margin-left: 10px
    margin-right: 10px
    margin-top: 14px
    overflow auto
    height 76%
    border: 1px solid #DCDFE6;

.theme-dark
  .left-search
    background-color: #042a85;
    >>>.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content
      color: #fff !important;
    .serach
      background: #002799
    .dataStaticTree
      border: 1px solid rgba(5, 126, 250, 0.3);
    .el-tree .custom-tree-node
      .node-txt
        color: #fff;
</style>
